import { attachmentFileName } from '@gozoki/tools'

/**
 * Extrait le nom de fichier d'un header `Content-Disposition`
 * (ex: `attachment; filename=fiches-collaborateurs.xlsx`) : `attachmentFileName` de
 * `@gozoki/tools`, seul parseur de cet en-tête.
 */
export const extractContentDispositionFilename = (
  contentDisposition: string | undefined,
  fallback: string,
): string => attachmentFileName(contentDisposition, fallback)
